import { useQuery } from "@tanstack/react-query";

import { BANNER_CACHE_KEYS } from "./keys";

import { BannerRepository } from "@/repositories/banner";

const bannerRepository = new BannerRepository();

export const useGetAllBanners = () => {
  return useQuery({
    queryKey: BANNER_CACHE_KEYS.LIST,
    queryFn: () => bannerRepository.findAll(),
  });
};
